module.exports = __webpack_public_path__ + "img/hummingbird-large-cc-by-sa-4.f33ece1.jpg";